import {
  setLocalStorageItem
  // getLocalStorageItem
} from "@/utils/localStorageUtility";
// import apiEmployeeAccess from "@/services/employeeAccess/api/apiEmployeeAccess";
// import { login_url } from "@/common/endpoints";
// let { resultModel } = require("@/model/employeeAccess/result/resultModel");
import { routes } from "@/model/employeeAccess/modules";
import store from "@/store";
function getSortedPermittedModules(item) {
  const permittedModules = item;
  let tempPermitted = [];
  for (let i = 0; i < permittedModules.length; i++) {
    tempPermitted.push(permittedModules[i]);
  }
  for (let i = 0; i < tempPermitted.length; i++) {
    if (tempPermitted[i].name === "Dashboard") {
      tempPermitted.splice(i, 1);
    }
  }
  //sorted temporary permitted items array without Dashboard
  tempPermitted.sort(function(a, b) {
    const nameA = a.title.toUpperCase();
    const nameB = b.title.toUpperCase();
    if (nameA > nameB) {
      return -1;
    }
    if (nameA < nameB) {
      return 1;
    }
    return 0;
  });
  let sorted = [];
  //have the array named 'sorted' to keep Dashboard at first
  for (let i = 0; i < permittedModules.length; i++) {
    if (permittedModules[i].name === "Dashboard") {
      sorted.push(permittedModules[i]);
      break;
    }
  }
  //then pushed that sorted tempPermitted array items into array named as 'sorted' and using that array future purposes
  for (let i = 0; i < tempPermitted.length; i++) {
    sorted.push(tempPermitted[i]);
  }
  return sorted;
}

// Function to search for a key in JSON object
function searchJSONObj(key, obj) {
  for (let k in obj) {
    if (k === key) {
      return obj[k];
    } else if (typeof obj[k] === "object") {
      const result = searchJSONObj(key, obj[k]);
      if (result) {
        return result;
      }
    }
  }
  return null;
}

function storeInLocalStorage(item) {
  const sortedPermittedModules = getSortedPermittedModules(item.data);
  let filteredSortedPermittedModules = [];
  sortedPermittedModules.forEach(item => {
    const searchKey = item.route;
    const result = searchJSONObj(searchKey, routes);
    if (result) {
      let exist = false;
      filteredSortedPermittedModules.forEach(item => {
        if (searchKey === item.route) {
          exist = true;
        }
      });
      if (!exist) {
        filteredSortedPermittedModules.push(item);
      }
    }
  });
  // const userInfo = item.header;
  // saving in local storage
  // setLocalStorageItem(
  //   "eapPermittedModules",
  //   JSON.stringify(filteredSortedPermittedModules)
  // );
  // console.log(userInfo);
  // setLocalStorageItem("eapUserInfo", JSON.stringify(userInfo));
  setLocalStorageItem("eapLoggedIn", JSON.stringify(true));
  // setLocalStorageItem("eap-bearer-token", item.message);
  return JSON.stringify(filteredSortedPermittedModules);
}

// /**
//  * Login to Employee Access
//  * @param credential
//  */
// async function login(credential) {
//   return apiEmployeeAccess.loginPost(login_url, credential);
// }
//
// async function loginUser(payload) {
//   const response = await login(payload);
//   const data = response.data;
//   if (data.header !== null && data.data !== null) {
//     resultModel = data;
//     if (resultModel.code === 200) {
//       if (payload.username !== "" && payload.password !== "") {
//         if (resultModel.header.employeeId !== null) {
//           if (payload.username === resultModel.header.userName) {
//             storeInLocalStorage(resultModel);
//             // // routing towards Dashboard
//             // this.$router.replace({ name: "EmployeeAccess_Dashboard" });
//             // commitUser(context, user);
//             // return Promise.resolve(returnOrganizedResponse);
//           }
//         }
//       }
//     }
//   } else {
//     return Promise.reject(data.message);
//   }
// }
//
// async function autoLoginUserPost(credential) {
//   return apiEmployeeAccess.loginPostAuto(login_url, credential);
// }
//
// async function autoLoginUser(payload) {
//   setLocalStorageItem("eap-bearer-token", payload.token);
//   const response = await autoLoginUserPost(payload);
//   const data = response.data;
//   if (data.header !== null && data.data !== null) {
//     resultModel = data;
//     if (resultModel.code === 200) {
//       if (payload.userName !== "") {
//         if (resultModel.header.employeeId !== null) {
//           if (payload.userName === resultModel.header.userName) {
//             storeInLocalStorage(resultModel);
//             // // routing towards Dashboard
//             // this.$router.replace({ name: "EmployeeAccess_Dashboard" });
//             // commitUser(context, user);
//             // return Promise.resolve(returnOrganizedResponse);
//           }
//         }
//       }
//     }
//   } else {
//     return Promise.reject(data.message);
//   }
// }
//
// function getStoredToken() {
//   return getLocalStorageItem("eap-bearer-token");
// }

function getStoredPermissions() {
  // return JSON.parse(getLocalStorageItem("eapPermittedModules"));
  // console.log(store.getters["user/getPermissions"]);
  return store.getters["user/getPermissions"];
}

function getStoredUserInfo() {
  // return getLocalStorageItem("eapUserInfo");
  return store.getters["user/getUser"];
}

/**
 * Return logged in status
 * @return {Boolean|boolean}
 */
function getStoredLoggedInInfo() {
  // return JSON.parse(getLocalStorageItem("eapLoggedIn"));
  let loggedIn = false;
  const user = store.getters["user/getUser"];
  if (user) {
    loggedIn = true;
  }
  return loggedIn;
}

function getPayloadForPermissions() {
  return "/".concat(store.getters["user/getUser"]).concat("/EAP");
}

export {
  getStoredLoggedInInfo,
  getStoredPermissions,
  getStoredUserInfo,
  storeInLocalStorage,
  getPayloadForPermissions
};
